namespace GeniuzPOS.LogManage {
    export namespace LogUserLockErrorPasswordService {
        export const baseUrl = 'LogManage/LogUserLockErrorPassword';

        export declare function Create(request: Serenity.SaveRequest<LogUserLockErrorPasswordRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<LogUserLockErrorPasswordRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<LogUserLockErrorPasswordRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<LogUserLockErrorPasswordRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "LogManage/LogUserLockErrorPassword/Create",
            Update = "LogManage/LogUserLockErrorPassword/Update",
            Delete = "LogManage/LogUserLockErrorPassword/Delete",
            Retrieve = "LogManage/LogUserLockErrorPassword/Retrieve",
            List = "LogManage/LogUserLockErrorPassword/List"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List'
        ].forEach(x => {
            (<any>LogUserLockErrorPasswordService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
